// extracted by mini-css-extract-plugin
module.exports = {"content":"FormWrapper_content__ygs00","title":"FormWrapper_title__eZTp5","form":"FormWrapper_form__2k2DQ","error":"FormWrapper_error__KaMCL","message":"FormWrapper_message__1Tq7M"};